module.exports = __webpack_public_path__ + "static/media/has-containers-empty.1d1fa642.svg";